import { useEffect, useRef, useState, ReactNode } from 'react';
import styles from './PageTransition.module.scss';

interface Props {
  page: number;
  children: ReactNode;
}

export const PageTransition = ({ page, children }: Props) => {
  const prevPageRef = useRef(page);
  const [animClass, setAnimClass] = useState('');
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (prevPageRef.current === page) return;

    const direction = page > prevPageRef.current ? 'next' : 'prev';
    prevPageRef.current = page;

    if (timerRef.current) clearTimeout(timerRef.current);
    setAnimClass('');

    requestAnimationFrame(() => {
      setAnimClass(
        direction === 'next' ? styles.slideFromRight : styles.slideFromLeft
      );
      timerRef.current = setTimeout(() => setAnimClass(''), 400);
    });
  }, [page]);

  return <div className={`${styles.wrapper} ${animClass}`}>{children}</div>;
};
